import React from 'react';

import { Typography } from '@material-ui/core';

export default function Unauthorized(): JSX.Element {
  return <Typography variant="h5">Unauthorized: check roles needed for access</Typography>;
}
